export default {
    props: {
        layoutEndRadialAngle: {
            type: Number,
            default: undefined,
            kComposite: 'layout.endRadialAngle'
        }, 
        layoutGridComponentSpacingX: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.componentSpacingX'
        }, 
        layoutGridComponentSpacingY: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.componentSpacingY'
        }, 
        layoutGridOffsetX: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.offsetX'
        }, 
        layoutGridOffsetY: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.offsetY'
        }, 
        layoutGridWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.width'
        }, 
        layoutHorizontalSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.horizontalSeparation'
        }, 
        layoutIterations: {
            type: Number,
            default: undefined,
            kComposite: 'layout.iterations'
        }, 
        layoutLayerSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.layerSeparation'
        }, 
        layoutNodeDistance: {
            type: Number,
            default: undefined,
            kComposite: 'layout.nodeDistance'
        }, 
        layoutRadialFirstLevelSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.radialFirstLevelSeparation'
        }, 
        layoutRadialSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.radialSeparation'
        }, 
        layoutStartRadialAngle: {
            type: Number,
            default: undefined,
            kComposite: 'layout.startRadialAngle'
        }, 
        layoutSubtype: {
            type: String,
            default: undefined,
            kComposite: 'layout.subtype'
        }, 
        layoutTipOverTreeStartLevel: {
            type: Number,
            default: undefined,
            kComposite: 'layout.tipOverTreeStartLevel'
        }, 
        layoutType: {
            type: String,
            default: undefined,
            kComposite: 'layout.type'
        }, 
        layoutUnderneathHorizontalOffset: {
            type: Number,
            default: undefined,
            kComposite: 'layout.underneathHorizontalOffset'
        }, 
        layoutUnderneathVerticalSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.underneathVerticalSeparation'
        }, 
        layoutUnderneathVerticalTopOffset: {
            type: Number,
            default: undefined,
            kComposite: 'layout.underneathVerticalTopOffset'
        }, 
        layoutVerticalSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.verticalSeparation'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/Layout.js